const manifest = {
	Divider: require('./Divider').default,
	Drawer: require('./SideDrawer').default,
	SideDrawer: require('./SideDrawer').default,
	SnackAlert: require('./SnackAlert').default,
	Snackbar: require('./Snackbar').default,
};

export default manifest;
